export default "__VITE_ASSET__MlpCfW4o__";